<template>
  <div class="nps-survey"></div>
</template>

<script>
import windowUtils from '@/utils/window-utils';

const NpsSurvey = {
  name: 'NpsSurvey',

  mounted() {
    this.run();
  },

  beforeDestroy() {
    this.stop();
  },

  methods: {
    async run() {
      this.logger.log('run', {npsMode: this.$store.state.npsMode});

      const win = windowUtils.getWindow();
      const {os, browser} = windowUtils.getParsedUserAgent();

      try {
        if (!win.WootricSurvey) {
          await windowUtils.loadScript('https://cdn.wootric.com/wootric-sdk.js');
        }

        this.logger.log('WootricSurvey', {version: win.WootricSurvey.version()});

        const {
          machineId, uuid, product, locale, current: env
        } = this.$store.state.g2wEnv;
        const joinInfo = this.$store.state.g2wSession.joinInfo;

        const alwaysShow = (this.$store.state.npsMode === 'always');
        win.wootric_survey_immediately = alwaysShow;
        win.wootric_no_surveyed_cookie = alwaysShow;

        const webinarType = this.getWebinarType(this.$store.getters['g2wWebinar/experienceType']);
        const language = this.getLanguage(locale);

        win.wootricSettings = {
          account_token: env.wootric.token,
          email: joinInfo.registrantEmail || 'unknown@logmein.com',
          product_name: product,
          language,
          modal_theme: 'dark',
          modal_footprint: 'compact',
          created_at: `${Math.floor(Date.now() / 1000)}`,
          properties: {
            browser: `${browser.name} ${browser.major}`,
            WebinarType: `${webinarType} (G2W Unified App)`,
            BrowserBrand: browser.name,
            OSType: os.name,
            os: `${os.name} ${os.version}`,
            webinarKey: joinInfo.webinarKey,
            sessionId: joinInfo.sessionKey,
            registrantKey: joinInfo.registrantKey,
            loggingUuid: uuid,
            machineId
          }
        };

        this.logger.log('settings', {
          wootricSettings: win.wootricSettings,
          wootric_survey_immediately: win.wootric_survey_immediately,
          wootric_no_surveyed_cookie: win.wootric_no_surveyed_cookie
        });

        win.WootricSurvey.run(win.wootricSettings);
      } catch (error) {
        this.logger.log('cannot run', {
          error,
          npsMode: this.$store.state.npsMode,
          settings: win.wootricSettings
        });
      }
    },

    stop() {
      const win = windowUtils.getWindow();

      if (win.WootricSurvey) {
        win.WootricSurvey.stop();
      }
    },

    getWebinarType(experienceType = '') {
      let webinarType;

      switch (experienceType.toLowerCase()) {
        case 'classic': webinarType = 'Classic'; break;
        case 'broadcast': webinarType = 'Broadcast'; break;
        case 'simulive': webinarType = 'Simulive'; break;
        default: webinarType = experienceType; break;
      }

      return webinarType;
    },

    getLanguage(locale = '') {
      // https://docs.wootric.com/javascript/#custom-language-setting
      let language = locale;
      if (/^zh$/i.test(locale)) {
        language = 'cn_s';
      }
      return language.toUpperCase();
    }
  }
};

export default NpsSurvey;
</script>

<style lang="sass">
  @import 'src/scss/mixins'

  #wootric-modal
    &.dark
      .wootric-footer
        color: #b9b9b9

    @include layout-horizontal
      left: 94px !important
      width: auto !important
</style>
